import * as React from 'react';
import UserAvatar from './UserAvatar';

interface IProps {
  users: Odoo.User[];
  size?: React.ComponentProps<typeof UserAvatar>['size'];
}

const UserAvatarStack: React.FC<IProps> = ({ users, size }) => {
  return (
    <div className="user-avatar-stack">
      {users.map(user => (
        <UserAvatar key={user.id} user={user} size={size} />
      ))}
    </div>
  );
};

export default UserAvatarStack;
